<div class="main">
  <div class="loader" *ngIf="showLoader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div class="header">
    {{dialogData.name}} <span *ngIf="dialogData.sin"> - {{dialogData.sin}}</span>
    <i class="material-icons" (click)="closeModal('no');">clear</i>
  </div>
  <div class="filter_container">
    <div class="left_sec" *ngIf="showDateTime">
      <div class="input">
        <div class="label">
          {{'CONFIRMMODAL.arrived_at' | translate}} :
        </div>
        <div class="date-time-wrapper"> 
        <input type="text" style="margin-left:62px; width: 120px;" class="inputField" [(ngModel)]="arrival.date" (click)="arrivalTime.open()" [matDatepicker]="arrivalTime" />
        <mat-datepicker #arrivalTime (closed)="setDateTime(arrival,'arrived_at');picker1.open()">
        </mat-datepicker>
        <input style="width:120px;" type="text" class="inputField" [(ngModel)]="arrival.time" [ngxTimepicker]="picker1">
        <ngx-material-timepicker class="timePick" #picker1 (closed)="setDateTime(arrival,'arrived_at')">
        </ngx-material-timepicker>
        <i class="material-icons pull-right add-icon calendar">date_range</i>
        </div>
      </div>
    </div>
    <div class="left_sec" *ngIf="showDateTime && dialogData.shipmentType!='arrived'">
      <div class="input">
        <div class="label">
          {{'CONFIRMMODAL.finished_at' | translate}} :
        </div>
        <div class="date-time-wrapper">
        <input type="text" style="margin-left:40px; width: 120px;" class="inputField" [(ngModel)]="completion.date" (click)="arrivalTime.open()" [matDatepicker]="arrivalTime" />
        <mat-datepicker #arrivalTime (closed)="setDateTime(completion,'finished_at');picker1.open()">
        </mat-datepicker>
        <input style="width:120px;" type="text" class="inputField" [(ngModel)]="completion.time" [ngxTimepicker]="picker1">
        <ngx-material-timepicker class="timePick" #picker1 (closed)="setDateTime(completion,'finished_at')">
        </ngx-material-timepicker>
        <i class="material-icons pull-right add-icon calendar">date_range</i>
        </div>
     </div>
    </div>
  </div>
  <div class="section">
    <div class="question">{{dialogData.text}}</div>
    <div class="reasonsMenu" *ngIf="showReason" >
      <mat-select class="inputSelect" [placeholder]="'Reason'" [(ngModel)]="selectedReason">
        <mat-option *ngFor="let reason of reasons" [value]="reason" (onSelectionChange)="reasonChange($event, reason)">
           {{reason}}
        </mat-option>
    </mat-select>
    </div>
    <div class="reasonBox" *ngIf="other">
      <textarea [required]="showReason" placeholder="Reason" autofocus="false" [(ngModel)]="reason"> </textarea>
    </div>
    
    <div class="submitButtonNo" (click)="closeModal('no');">
      <div class="button" style="background-color: #a0a0a0;">
        {{'CONFIRMMODAL.no' | translate}}
      </div>
    </div>
    <div class="submitButtonYes" (click)="confirm();">
      <div class="button" >
        {{'CONFIRMMODAL.yes' | translate}}
      </div>
    </div>
  </div>
</div>